<script setup lang="ts">
import type FavouriteLocation from '@/classes/favouriteLocation';
import { computed, ref } from 'vue';

const props = defineProps<{
  requestedLocation: FavouriteLocation
}>()

const emit = defineEmits<{
  (e: 'flag-approved', id: string): void
  (e: 'flag-rejected', id: string): void
  (e: 'flag-cleared', id: string): void
  (e: 'click', id: string): void
  (e: 'history-delete', id: string): void
}>()

const approvedFlag = ref(false)
const flagAsApproved = () => {
  if (approvedFlag.value) {
    approvedFlag.value = false
    emit('flag-cleared', props.requestedLocation.localId)
    return
  }
  approvedFlag.value = true
  rejectedFlag.value = false
  emit('flag-approved', props.requestedLocation.localId)
}

const rejectedFlag = ref(false)
const flagAsRejected = () => {
  if (rejectedFlag.value) {
    rejectedFlag.value = false
    emit('flag-cleared', props.requestedLocation.localId)
    return
  }
  rejectedFlag.value = true
  approvedFlag.value = false
  emit('flag-rejected', props.requestedLocation.localId)
}

const already_approved = computed(
  () =>
    props.requestedLocation.approvalStatus === 'approved' &&
    props.requestedLocation.visibility === 'fleet',
)

</script>
<template>
  <v-card class="pa-4" @click.stop="emit('click', props.requestedLocation.localId)">
    <v-row no-gutters class="flex-nowrap mb-10" justify="space-between" align="center">
      <div>
        <v-card-title> {{ props.requestedLocation.name }} </v-card-title>
        <v-card-subtitle> {{ props.requestedLocation.requestedByUser }}</v-card-subtitle>
      </div>
      <div v-if="already_approved">
        <v-btn icon flat density="compact" color="pwt_alabaster" @click.stop="emit('history-delete', props.requestedLocation.localId)">
          <v-icon
            icon="mdi-trash-can-outline"
            color="pwt_light_grey"
          />
        </v-btn>
      </div>
      <div v-else>
        <v-btn icon flat density="compact" color="pwt_alabaster" @click.stop="flagAsApproved">
          <v-icon
            :icon="approvedFlag ? 'mdi-check-circle' : 'mdi-check-circle-outline'"
            color="pwt_green"
          />
        </v-btn>
        <v-btn icon flat density="compact" color="pwt_alabaster" @click.stop="flagAsRejected">
          <v-icon
            :icon="rejectedFlag ? 'mdi-close-circle' : 'mdi-close-circle-outline'"
            color="pwt_red"
          />
        </v-btn>
      </div>
    </v-row>
  </v-card>
</template>
